import { Provider, inject } from '@angular/core';
import { CalGtmService } from '@cal-analytics/gtm';
import { ShellStore } from '@partners/state';
import { GtmOtpWarningCardService } from './gtm-otp-warning-card.service';
import { GtmOtpWarningService } from './gtm-otp-warning.service';

export const provideOtpWarningServiceProvider = (): Provider => {
  return {
    provide: CalGtmService,
    useFactory: () => {
      const shellStore = inject(ShellStore);

      const canMatchCard$$ = shellStore.matchCard$$;

      if (canMatchCard$$()) {
        return new GtmOtpWarningCardService();
      }

      return new GtmOtpWarningService();
    }
  };
};
